export default {
  switchMum (state, isShow) {
    state.showMum = isShow
  },
  playMsg (state, msg) {
    state.hintMsg = msg
    // 两秒后隐藏
    setTimeout(() => {
      state.hintMsg = ''
    }, 2000)
  },
  setUserInfo (state, userInfo) {
    state.user = userInfo
  },
  setPopalories (state, pop) {
    state.pop_calories = pop
  },
  setGroup (state, group) {
    state.group = group
  }
}
